import { render, staticRenderFns } from "./DynamicProductsDiscounts.vue?vue&type=template&id=0c2eb83a&scoped=true&"
import script from "./DynamicProductsDiscounts.vue?vue&type=script&lang=js&"
export * from "./DynamicProductsDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2eb83a",
  null
  
)

export default component.exports